module.exports = __webpack_public_path__ + "static/img/yx4.8581438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx4.jpg
// module id = uDUj
// module chunks = 1